<div class=" row confirm-container">
  @if (!reservationCancelled) {
    <div class="col-lg-6 summary-container">
      <app-activity-schedule (reservationCancelled)="reservationStatus($event)"
      (reservationAllCancelled)="showSchedule($event)"></app-activity-schedule>
    </div>
  }
  @if (!reservationCancelled) {
    <div class=' col-lg-6 summary-container payment-summary-container'>
      @if (activityService.availableDates) {
        @if (classDetail && ConfirmationData) {
          <div class="reser-summary-header">{{'ReservationSummary' |
            translate}}
          </div>
        }
        @if (classDetail && ConfirmationData) {
          <div class="class-info">
            <h1 class="class-info__detail__name">{{lessonName}}</h1>
            <div class="class-info__detail__location">
              <mat-icon class="location_on" aria-hidden="false" aria-label="location">location_on</mat-icon>
              &nbsp;{{Locations}}
            </div>
            <div class="class-info__detail__item pt-3">
              <label for="start-date" class="class-info__detail__item--label">{{'bookingSize' |
              translate}}</label>
              <div class="class-info__detail__item--value">{{coverSize}}
              </div>
            </div>
            @if (CoverTypeQuantities && CoverTypeQuantities.length) {
              <div class="class-info__detail__item pt-3" style="width: 100%; height: auto;"
                >
                <label for="start-date" class="class-info__detail__item--label">{{'coverType' | translate}}</label>
                <div class="cover-types-container">
                  @for (cover of CoverTypeQuantities; track cover; let coverIndex = $index) {
                    @if (cover.Covers) {
                      <div class="class-info__detail__item--value">
                        @if (coverIndex) {
                          <span class="cover-type-pipe">|</span>
                        }
                        {{cover.CoverTypeName}} : {{cover.Covers}}
                      </div>
                    }
                  }
                </div>
              </div>
            }
            <div class="class-info__detail__item--confirmation pt-3">
              <label for="start-date" class="class-info__detail__item--label">{{'confirmation' |
              translate}}</label>
              <div class="class-info__detail__item--value">{{ConfirmationData.ConfirmationCode}}
              </div>
            </div>
            <div class="class-info__detail--content pt-2">
              <div class="class-info__detail__item">
                <label for="start-date" class="class-info__detail__item--label">{{'Start Date' |
                translate}}</label>
                @if (activityService.isClassBokking) {
                  <div class="class-info__detail__item--value">
                    {{ConfirmationData.StartDate | localizeDate:'MM/D/yyyy'}}
                  </div>
                }
                @if (!activityService.isClassBokking) {
                  <div class="class-info__detail__item--value">
                    {{activityService.availableDates ? (activityService.availableDates[0].StartDate |
                    date:'MM/dd/yyyy') : (ConfirmationData.StartDate | localizeDate:'MM/D/YYYY')}}
                  </div>
                }
              </div>
              <div class="class-info__detail__item">
                <label for="endDate" class="class-info__detail__item--label">{{'End Date' | translate}}</label>
                @if (activityService.isClassBokking) {
                  <div class="class-info__detail__item--value">
                  {{ConfirmationData.EndDate | localizeDate:'MM/D/YYYY'}}</div>
                }
                @if (!activityService.isClassBokking) {
                  <div class="class-info__detail__item--value">
                    {{activityService.availableDates ? (
                    activityService.availableDates[activityService.availableDates.length -1].StartDate |
                  date:'MM/dd/yyyy' ): (ConfirmationData.EndDate | localizeDate:'MM/D/YYYY') }}</div>
                }
              </div>
            </div>
          </div>
        }
      }
      <!-- open booking summery start -->
      @if (!classDetail && ConfirmationData) {
        <div class="reser-summary-header">{{'ReservationSummary' | translate}}
        </div>
      }
      @if (!classDetail && ConfirmationData) {
        <div class="class-info">
          <label for="start-date" class="class-info__detail__item--label">{{'location' | translate}}</label>
          <div class="class-info__detail__location">
            <mat-icon class="location_on" aria-hidden="false" aria-label="location">location_on</mat-icon>
            &nbsp;{{Locations}}
          </div>
          <div class="class-info__detail__item pt-3">
            <label for="start-date" class="class-info__detail__item--label">{{'bookingSize' | translate}}</label>
            <div class="class-info__detail__item--value">{{coverSize}}
            </div>
          </div>
          @if (CoverTypeQuantities && CoverTypeQuantities.length) {
            <div class="class-info__detail__item pt-3" style="width: 100%; height: auto;"
              >
              <label for="start-date" class="class-info__detail__item--label">{{'coverType' | translate}}</label>
              <div class="cover-types-container">
                @for (cover of CoverTypeQuantities; track cover; let coverIndex = $index) {
                  @if (cover.Covers) {
                    <div class="class-info__detail__item--value">
                      @if (coverIndex) {
                        <span class="cover-type-pipe">|</span>
                      }
                      {{cover.CoverTypeName}} : {{cover.Covers}}
                    </div>
                  }
                }
              </div>
            </div>
          }
          <div class="class-info__detail__item--confirmation pt-3">
            <label for="start-date" class="class-info__detail__item--label">{{'confirmation' | translate}}</label>
            <div class="class-info__detail__item--value">{{ConfirmationData.ConfirmationCode}}
            </div>
          </div>
          <div class="class-info__detail--content pt-2">
            <div class="class-info__detail__item">
              <label for="start-date" class="class-info__detail__item--label">{{'Start Date' | translate}}</label>
              <div class="class-info__detail__item--value"> {{activityService.availableDates ?
                (activityService.availableDates[0]?.StartTime |
                date:'MM/dd/yyyy') : (openBookingStartDate | localizeDate:'MM/D/YYYY')}}
              </div>
            </div>
            <div class="class-info__detail__item">
              <label for="endDate" class="class-info__detail__item--label">{{'End Date' | translate}}</label>
              <div class="class-info__detail__item--value">
                {{activityService.availableDates ?
                (activityService.availableDates[activityService.availableDates.length -1]?.EndTime |
              date:'MM/dd/yyyy') : (openBookingStartDate | localizeDate:'MM/D/YYYY')}} </div>
            </div>
          </div>
        </div>
      }
      <!-- open booking summery end -->
      @if (ratePlan && TotalAmount > 0 ) {
        <div class="payment-content">
          <div class="booking-summary activity-header">
            {{'PaymentSummary' | translate}}
          </div>
          <div class="rate-header  rate-sub-content">
            {{'Rates' | translate}}
          </div>
          @if (ratePlanList) {
            <div>
              @if (ratePlanList?.RatePlanVariants?.TotalBaseRate) {
                <div class="row rate-sub-content">
                  <div class="col-lg-9 font-size-14"> {{'TotalBaseRate' | translate}}</div>
                  <div class="col-lg-3 text-align-right">{{OperationCurrency}}
                    {{ratePlanList.RatePlanVariants.TotalBaseRate | currencyDecimalFormatter}}
                  </div>
                </div>
              }
              @if (ratePlanList?.RatePlanVariants?.LocationVariant) {
                <div class="row rate-sub-content">
                  <div class="col-lg-9 font-size-14"> {{'LocationVariant' | translate}}</div>
                  <div class="col-lg-3 text-align-right">{{OperationCurrency}}
                    {{ratePlanList.RatePlanVariants.LocationVariant | currencyDecimalFormatter}}
                  </div>
                </div>
              }
              @if (ratePlanList?.RatePlanVariants?.InstructorVariant) {
                <div class="row rate-sub-content">
                  <div class="col-lg-9 font-size-14"> {{'InstructorVariant' | translate}}</div>
                  <div class="col-lg-3 text-align-right">{{OperationCurrency}}
                    {{ratePlanList.RatePlanVariants.InstructorVariant | currencyDecimalFormatter}}
                  </div>
                </div>
              }
              @for (bookingType of ratePlanList?.bookingTypeVariants; track bookingType; let index = $index) {
                <div>
                  @if (bookingType.bookingTypes && bookingType.Variant) {
                    <div class="row rate-sub-content">
                      <div class="col-lg-9 font-size-14"> {{bookingType.BookingTypeName}}&nbsp; X
                      &nbsp;{{bookingType.bookingTypes}}</div>
                      <div class="col-lg-3 text-align-right">{{OperationCurrency}} {{bookingType.Variant | currencyDecimalFormatter}}
                      </div>
                    </div>
                  }
                </div>
              }
              @for (cover of ratePlanList?.coverTypeVariants; track cover; let index = $index) {
                <div>
                  @if (cover.covers && cover.Variant) {
                    <div class="row rate-sub-content">
                      <div class="col-lg-9 font-size-14"> {{cover.CoverTypeName}}&nbsp; X &nbsp;{{cover.covers}}</div>
                      <div class="col-lg-3 text-align-right">{{OperationCurrency}} {{cover.Variant | currencyDecimalFormatter}}
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
          @if (ratePlan) {
            <div class="column">
              <div class="row rate-sub-content">
                <div class="col-lg-9 font-size-14">{{'TotalSessionCharge' | translate}}</div>
                <div class="col-lg-3 text-align-right">{{OperationCurrency}} {{(ratePlan.TotalRatePlan !== null ?
                  (ratePlan.TotalRatePlan
                  | currencyDecimalFormatter) : '0.00') }}
                </div>
              </div>
              @if (ratePlan.TotalMemberShipVariant) {
                <div class="row rate-sub-content">
                  <div class="col-lg-9 font-size-14">{{'MembershipDiscount' | translate}}
                  </div>
                  <div class="col-lg-3 text-align-right">{{OperationCurrency}} {{(ratePlan.TotalMemberShipVariant
                  | currencyDecimalFormatter)}}</div>
                </div>
              }
              @if (ConfirmationData?.PrepaymentState === PartyPrepaymentState?.DepositCollected) {
                <div class="row rate-sub-content"
                  >
                  <div class="col-lg-9 font-size-14">{{'DepositAmount' | translate}}</div>
                  <div class="col-lg-3 text-align-right">{{OperationCurrency}} {{ConfirmationData.DepositPaid
                    | currencyDecimalFormatter}}
                  </div>
                </div>
              }
            </div>
          }
          <hr />
          @if (ConfirmationData?.PrepaymentState !== PartyPrepaymentState?.DepositCollected) {
            <div class="row rate-sub-content total-amount"
              >
              <div class="col-lg-9">{{'totalAmount' | translate}}</div>
              <div class="col-lg-3 text-align-right">{{OperationCurrency}} {{TotalAmount | currencyDecimalFormatter }}
              </div>
            </div>
          }
          @if (ConfirmationData?.PrepaymentState === PartyPrepaymentState?.DepositCollected) {
            <div class="row rate-sub-content total-amount"
              >
              <div class="col-lg-9">{{'RemAmountToBePayed' | translate}}</div>
              <div class="col-lg-3 text-align-right">{{OperationCurrency}} {{TotalAmount | currencyDecimalFormatter }}
              </div>
            </div>
          }
          <!-- <div class="row rate-sub-content total-amount" @if (activityService.TotalRefundAmount > 0) {
          <div class="col-lg-9">{{'totalRefundAmount' | translate}}</div>
          <div class="col-lg-3 text-align-right">{{OperationCurrency}}{{(activityService.TotalRefundAmount | currencyDecimalFormatter) }}
          </div>
        </div> } -->
      </div>
    }
  </div>
}

@if (reservationCancelled) {
  <div class="confirmation-summary col-lg-6 summary-container">
    <div class="reservation-confirmation__title confirmation-title">
      {{'checkInMessage' | translate }} {{SeatedType !=='' ? SeatedType : PartyState[4]}}
    </div>
    <div class="reservation-confirmation__reservation-details">
      <div class="reservation-confirmation__reservation-info">
        <span class="default-sub-header">{{activityService.restaurantWidgetSettings$.value.PropertyType}}</span>
        <span class="reservation-summary">{{activityService.restaurantWidgetSettings$.value.RestaurantName}}</span>
      </div>
      <div class="reservation-confirmation__reservation-info reservation-confirmation__date">
        <span class="default-sub-header">{{'date' | translate}}</span>
        <span class="reservation-summary">{{activityService.editPartyData$.value.ReservedFor ? ( activityService.editPartyData$.value.ReservedFor | localizeDate: 'DD MMM,yyyy') : ( activityService.editPartyData$.value.WishedTime | localizeDate: 'DD MMM,yyyy')}}</span>
      </div>
      <div class="reservation-confirmation__reservation-info reservation-confirmation__time">
        <span class="default-sub-header">{{'time' | translate}}</span>
        <span class="reservation-summary">{{activityService.editPartyData$.value.ReservedFor ? (activityService.editPartyData$.value.ReservedFor | localizeDate: 'LT') : (activityService.editPartyData$.value.WishedTime | localizeDate: 'LT')}}</span>
      </div>
      <div class="reservation-confirmation__reservation-info">
        <span class="default-sub-header">{{'partySize' | translate}}</span>
        <span class="reservation-summary">{{activityService.editPartyData$.value.Size}}</span>
      </div>
      <div class="reservation-confirmation__reservation-info reservation-confirmation__code">
        <span class="default-sub-header">{{'confirmation' | translate}}</span>
        <span class="reservation-summary">{{activityService.editPartyData$.value.ConfirmationCode}}</span>
      </div>
      <div class="reservation-confirmation__reservation-info reservation-bookingReference__Id">
        <span class="default-sub-header">{{'bookingReferenceId' | translate}}</span>
        <span class="reservation-summary">{{activityService.editPartyData$.value.BookingReferenceId}}</span>
      </div>
    </div>
    <div class="confirmation-summary__cancelled-view"
      [ngStyle]="{'background-color':activityService.restaurantWidgetSettings$.value.WidgetCustomization.MaincontentBottomBackgroundColor}">
      <div class="confirmation-summary__header-data">{{'guestInfo' | translate}}</div>
      <div class="confirmation-summary__guest-info">
        <div class="confirmation-summary__guest-name">
          <span class="default-sub-header">{{'name' | translate}}</span>
          <span class="reservation-summary">{{activityService.editPartyData$.value.Contact.FirstName}}
          {{activityService.editPartyData$.value.Contact.LastName}}</span>
        </div>
        <div class="confirmation-summary__email">
          <span class="default-sub-header">{{'emailText' | translate}}</span>
          <span class="reservation-summary">{{activityService.editPartyData$.value.Contact.EmailAddress}}</span>
        </div>
        <div class="confirmation-summary__phone">
          <span class="default-sub-header">{{'phoneText' | translate}}</span>
          <span class="reservation-summary">{{activityService.editPartyData$.value.Contact.PhoneNumber}}</span>
        </div>
      </div>
      <div class="confirmation-summary__header-data">{{'reservationInfo' | translate}}</div>
      <div class="confirmation-summary__reservation-info">
        <div class="confirmation-summary__property">
          <span class="default-sub-header">{{activityService.restaurantWidgetSettings$.value.PropertyType}}</span>
          <span class="reservation-summary">{{activityService.restaurantWidgetSettings$.value.RestaurantName}}</span>
        </div>
        <div class="confirmation-summary__phone-data">
          <span class="default-sub-header">{{'phoneText' | translate}}</span>
          <span class="reservation-summary">{{activityService.restaurantWidgetSettings$.value.PhoneNumber}}</span>
        </div>
        <div class="confirmation-summary__address">
          <span class="default-sub-header">{{'address' | translate}}</span>
          <span
            class="reservation-summary">{{activityService.restaurantWidgetSettings$.value.Street1}}{{activityService.restaurantWidgetSettings$.value.Street2}},
            {{activityService.restaurantWidgetSettings$.value.City}},
          {{activityService.restaurantWidgetSettings$.value.Country}}</span>
        </div>
      </div>
      <div class="row">
        <app-button class="btn-class" [buttontype]="BookAnotherReservationBtn"
          (valueChange)="bookAnotherReservationBtn($event)">
        </app-button>
        @if (activityService.isSummaryFromCart) {
          <app-button class="btn-class" [buttontype]="backToCartSummarybtn"
            (valueChange)="backToCartSummary($event)">
          </app-button>
        }
      </div>
    </div>
  </div>
}


</div>
